// Fancybox.bind("[data-fancybox]", {
//   // Your custom options
// });

var swiper = new Swiper(".home-reviews", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
var swiper = new Swiper(".game-main", {
  slidesPerView: 1,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

var swiper = new Swiper(".main-reviews", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".main-tabs ul li a");
  const tabContents = document.querySelectorAll(".common-tab");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function (event) {
      event.preventDefault();

      // Remove active class from all tabs
      tabs.forEach((t) => t.classList.remove("active"));
      // Add active class to clicked tab
      this.classList.add("active");

      // Hide all tab contents
      tabContents.forEach((content) => content.classList.remove("active"));
      // Show the corresponding tab content
      tabContents[index].classList.add("active");
    });
  });
});
document.addEventListener("DOMContentLoaded", () => {
  const items = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");

  items.forEach((item) => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
      // Use a delay to check if the mouse is still in the menu
      setTimeout(() => {
        if (
          !item.matches(":hover") &&
          !item.querySelector("ul").matches(":hover")
        ) {
          item.removeAttribute("open");
        }
      }, 200); // 200ms delay
    });

    item.querySelector("ul").addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (
          !item.matches(":hover") &&
          !item.querySelector("ul").matches(":hover")
        ) {
          item.removeAttribute("open");
        }
      }, 200); // 200ms delay
    });
  });
});
// document.addEventListener("DOMContentLoaded", function () {
//   const list = document.querySelector(".all-brands");
//   const container = document.querySelector(".logo-container");

//   // Only run the script if the required elements exist
//   if (!list || !container) return;

//   let speed = 1; // Adjust scrolling speed
//   let animationFrame;

//   // Duplicate list items to create a seamless loop
//   function duplicateItems() {
//     const items = Array.from(list.children);
//     items.forEach((item) => {
//       const clone = item.cloneNode(true);
//       list.appendChild(clone);
//     });
//   }

//   // Start the infinite scroll animation
//   function startScrolling() {
//     list.style.transition = "none";
//     let scrollAmount = 0;

//     function scroll() {
//       scrollAmount += speed;
//       list.style.transform = `translateY(-${scrollAmount}px)`;

//       const firstItem = list.firstElementChild;
//       const firstItemHeight = firstItem.offsetHeight;

//       if (scrollAmount >= firstItemHeight) {
//         list.appendChild(firstItem); // Move the first item to the bottom
//         list.style.transition = "none";
//         scrollAmount -= firstItemHeight; // Reset scroll position without a jump
//         list.style.transform = `translateY(-${scrollAmount}px)`;
//       }

//       animationFrame = requestAnimationFrame(scroll);
//     }

//     scroll();
//   }

//   function stopScrolling() {
//     cancelAnimationFrame(animationFrame);
//   }

//   // duplicateItems(); // Ensure enough items for seamless scrolling
//   startScrolling();

//   // Pause scrolling when hovering
//   container.addEventListener("mouseenter", stopScrolling);
//   container.addEventListener("mouseleave", startScrolling);
// });

var swiperBottomScrollbarFull = new Swiper(".all-brandss", {
  direction: getDirection(),
  slidesPerView: 2,
  spaceBetween: 17,
  mousewheel: true,
  grabCursor: true,
  loop: true,
  autoplay: {
    delay: 500,
    disableOnInteraction: false,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 17,
    },
  },
  on: {
    resize: function () {
      swiperBottomScrollbarFull.changeDirection(getDirection());
    },
  },
});

function getDirection() {
  var windowWidth = window.innerWidth;
  var direction = window.innerWidth <= 760 ? "horizontal" : "vertical";

  return direction;
}

const rangevalue = document.querySelector(".slider-container .price-slider");
const rangeInputvalue = document.querySelectorAll(".range-input input");
// Set the price gap
let priceGap = 500;

// Adding event listners to price input elements
const priceInputvalue = document.querySelectorAll(".price-input input");
for (let i = 0; i < priceInputvalue.length; i++) {
  priceInputvalue[i].addEventListener("input", (e) => {
    // Parse min and max values of the range input
    let minp = parseInt(priceInputvalue[0].value);
    let maxp = parseInt(priceInputvalue[1].value);
    let diff = maxp - minp;

    if (minp < 0) {
      alert("minimum price cannot be less than 0");
      priceInputvalue[0].value = 0;
      minp = 0;
    }

    // Validate the input values
    if (maxp > 10000) {
      alert("maximum price cannot be greater than 10000");
      priceInputvalue[1].value = 10000;
      maxp = 10000;
    }

    if (minp > maxp - priceGap) {
      priceInputvalue[0].value = maxp - priceGap;
      minp = maxp - priceGap;

      if (minp < 0) {
        priceInputvalue[0].value = 0;
        minp = 0;
      }
    }

    // Check if the price gap is met
    // and max price is within the range
    if (diff >= priceGap && maxp <= rangeInputvalue[1].max) {
      if (e.target.className === "min-input") {
        rangeInputvalue[0].value = minp;
        let value1 = rangeInputvalue[0].max;
        rangevalue.style.left = `${(minp / value1) * 100}%`;
      } else {
        rangeInputvalue[1].value = maxp;
        let value2 = rangeInputvalue[1].max;
        rangevalue.style.right = `${100 - (maxp / value2) * 100}%`;
      }
    }
  });

  // Add event listeners to range input elements
  for (let i = 0; i < rangeInputvalue.length; i++) {
    rangeInputvalue[i].addEventListener("input", (e) => {
      let minVal = parseInt(rangeInputvalue[0].value);
      let maxVal = parseInt(rangeInputvalue[1].value);

      let diff = maxVal - minVal;

      // Check if the price gap is exceeded
      if (diff < priceGap) {
        // Check if the input is the min range input
        if (e.target.className === "min-range") {
          rangeInputvalue[0].value = maxVal - priceGap;
        } else {
          rangeInputvalue[1].value = minVal + priceGap;
        }
      } else {
        // Update price inputs and range progress
        priceInputvalue[0].value = minVal;
        priceInputvalue[1].value = maxVal;
        rangevalue.style.left = `${(minVal / rangeInputvalue[0].max) * 100}%`;
        rangevalue.style.right = `${
          100 - (maxVal / rangeInputvalue[1].max) * 100
        }%`;
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".tab-topcontent").forEach((tabContainer) => {
    const tabs = tabContainer.querySelectorAll("ul li");

    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        // Get the parent tab container
        const parentTabContainer = this.closest(".tab-topcontent");

        // Remove active class from all tabs in the same section
        parentTabContainer
          .querySelectorAll("ul li")
          .forEach((t) => t.classList.remove("active"));

        // Find the corresponding content wrapper within the same tab section
        const contentContainer = parentTabContainer.nextElementSibling; // Assuming content is right after tabs

        if (contentContainer) {
          // Remove active class from all tab contents in the same section
          contentContainer
            .querySelectorAll(".common-megatab")
            .forEach((pane) => pane.classList.remove("active"));

          // Activate the clicked tab and corresponding content
          this.classList.add("active");
          contentContainer
            .querySelector(`#${this.dataset.id}`)
            ?.classList.add("active");
        }
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".singl-megatab");
  const tabPanes = document.querySelectorAll(".singl-megatabcontent");

  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      // Remove active class from all tabs & content
      tabs.forEach((t) => t.classList.remove("active"));
      tabPanes.forEach((pane) => pane.classList.remove("active"));

      // Add active class to the clicked tab and corresponding content
      this.classList.add("active");
      document.getElementById(this.dataset.id).classList.add("active");
    });
  });
});

// document.querySelectorAll("summary").forEach((summary) => {
//   summary.addEventListener("click", function (event) {
//     event.preventDefault(); // Prevent default summary toggle behavior

//     // Close all other details elements
//     document.querySelectorAll("details").forEach((details) => {
//       if (details !== this.parentElement) {
//         details.removeAttribute("open");
//       }
//     });

//     // Toggle open on the clicked details
//     const parentDetails = this.parentElement;
//     if (!parentDetails.hasAttribute("open")) {
//       parentDetails.setAttribute("open", "");
//     } else {
//       parentDetails.removeAttribute("open");
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  let selectedSport = "baseball";
  let selectedTier = "bronze";
  let currentLink = null;

  const allProductDivs = document.querySelectorAll("section[featured-npcs]");
  const mainptab = document.querySelectorAll(".main-ptabs ul li a");
  const allmainTabs = document.querySelectorAll(".toggle-title");

  function updateVisibleProduct() {
    if (!selectedSport || !selectedTier || !currentLink) return;

    const combinedId = `${selectedSport}-${selectedTier}-${currentLink}`;
    // console.log(combinedId);
    // console.log(allProductDivs);

    allProductDivs.forEach((div) => {
      if (div.id === combinedId) {
        div.style.display = "block";
      } else {
        div.style.display = "none";
      }
    });
    mainptab.forEach((tab) => {
      tab.classList.remove("active");
    });

    // Inside this div, find the matching secondary-ptab button
    const matchingBtn = document.querySelector(
      `.main-ptabs ul li a[data-type="${selectedTier}"]`
    );

    if (matchingBtn) {
      matchingBtn.classList.add("active"); // trigger the button's click logic
    }
  }

  document.querySelectorAll(".main-ptab a").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      selectedSport = this.dataset.type;
      currentLink = this.dataset.link;
      // console.log(selectedTier);
      // console.log(currentLink);
      updateVisibleProduct();
    });
  });

  document.querySelectorAll(".secondary-ptab a").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      selectedTier = this.dataset.type;
      currentLink = this.dataset.link;
      // console.log(selectedTier);
      // console.log(currentLink);
      updateVisibleProduct();
    });
  });
  allmainTabs.forEach((tab) => {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      allmainTabs.forEach((div) => {
        div.closest(".single-thaccording").classList.remove("active");
      });
      this.closest(".single-thaccording").classList.add("active");
    });
  });

  document.querySelectorAll(".main-ptabs ul li a").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      const targetTier = this.dataset.type;
      // console.log(targetTier);
      if (!targetTier) return;

      // Find the currently visible product div
      const currentVisibleDiv = Array.from(
        document.querySelectorAll("section[featured-npcs]")
      ).find((el) => window.getComputedStyle(el).display !== "none");
      // console.log(currentVisibleDiv);

      if (!currentVisibleDiv) return;

      // Inside this div, find the matching secondary-ptab button
      const matchingBtn = currentVisibleDiv.querySelector(
        `.secondary-ptab a[data-type="${targetTier}"]`
      );

      if (matchingBtn) {
        matchingBtn.click(); // trigger the button's click logic
      }
    });
  });
});
